<template>
  <div class="news-ul">
    <div class="news-li" v-for="(item, index) in newsList" :key="index" @click="gotonewsDetails(item)">
      <div class="news-img">
        <img :src="item.image.url" v-if="item.image && item.image.url != undefined" />
        <img class="course-img-empty" v-else src="@/assets/images/logo-img.png" alt="">
      </div>
      <div class="news-text">
        <div class="news-title">{{ item.title }}</div>
        <div class="news-time">{{ item.createTimeFormat }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPageDetails } from '@/api/home'
export default {
  name: "index",
  props: {
    // 定义 courses 为数组类型，必填
    newsList: {
      type: Array,
      required: true,
      default: () => [] // 防止 undefined
    }
  },
  data() {
    return {

    };
  },
  methods: {
    gotonewsDetails(value) {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      if(value.isForward) {
        this.getPageDetails(value.id)
        window.open(value.h5Url, '_blank')
      }else {
        this.$router.push({ path: `/NewsDetails/${value.id}` }); // 动态路由传递课程 id
      }
    },
    getPageDetails(id) {
      getPageDetails({
        id: id
      }).then(res => {
      })
    },
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">
.news-ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .news-li:hover {
    .news-title {
      color: rgba(164, 18, 24, 1) !important;
    }
  }

  .news-li {
    width: calc(50% - 13px);
    display: flex;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;

    .news-text {
      margin-left: 20px;
      text-align: left;
      width: calc(100% - 200px);

      .news-title {
        color: rgba(38, 38, 38, 1);
        font-size: 18px;
        line-height: 26px;
        font-weight: bold;
        height: 78px;
        display: -webkit-box;
        -webkit-line-clamp: 3;        /* 限制显示两行 */
        -webkit-box-orient: vertical; /* 垂直排列 */
        overflow: hidden;
        text-overflow: ellipsis;      /* 溢出省略号 */
      }

      .news-time {
        color: rgba(115, 115, 115, 1);
        font-size: 16px;
        line-height: 16px;
        margin-top: 20px;
      }
    }

    .news-img {
      width: 180px;
      height: 128px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;  /* 保持比例填充并裁剪 */
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue